import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { compose } from 'recompose';
import DialogActions from './Dialog/DialogFooter';
import { withStyles } from '@material-ui/core';

const styles = theme => ({});

const Component = ({ classes }) => {
    return (
        <DialogActions style={{border:"none"}}>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container justify="flex-end">
                        <Typography style={{color:"#5a607a", fontStyle:'italic', fontSize:"13px", fontWeight:500}}>
                            Protected by&nbsp;
                            <a
                                href="https://data.inpi.fr/export/patents?format=pdf&ids=[%22FR3121764%22]&est=all"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{color:"#2d3882", textDecoration:"none", fontWeight:700}}
                            >
                                <img
                                    src="/showroom.png"
                                    alt="HIAsecure"
                                    style={{height:"18px", verticalAlign:"text-bottom", marginLeft:"4px"}}
                                />
                            </a>
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </DialogActions>
    );
}

export const enhance = compose(withStyles(styles));
export default enhance(Component);
